<template>
  <HeaderView />
  <router-view />
  <FooterView />
</template>

<script>
import FooterView from "./components/FooterView.vue";
import HeaderView from "./components/HeaderView.vue";

export default {
  components: {
    HeaderView,
    FooterView,
  },
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Be Vietnam Pro", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#app {
  color: $blue;
  overflow: hidden;

  .content {
    margin-inline: auto;
    width: 90%;

    @media (min-width: 1100px) {
      width: 85%;
    }
  }
}

.btn-style {
  padding: 10px 30px;
  background: $orange;
  color: white;
  font-size: 14px;
  border-radius: 30px;
  transition: 0.3s;
  box-shadow: 0 5px 10px rgba($color: $orange, $alpha: 0.5);

  &:hover {
    background: rgba($color: $orange, $alpha: 0.7);
  }
}

p {
  opacity: 0.6;
}

nav {
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
